import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import HowItWorks from "./components/HowItWorks";
import CreatorBenefits from "./components/CreatorBenefits";
import AIFeatures from "./components/AIFeatures";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import WaitlistCTA from "./components/WaitlistCTA";
import Footer from "./components/Footer";

const LandingPage = () => {
  const scrollToWaitlist = () => {
    const ctaSection = document.getElementById('get-monetized');
    ctaSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onWaitlistClick={scrollToWaitlist} />
      <main>
        <HeroSection onWaitlistClick={scrollToWaitlist} />
        <HowItWorks />
        <CreatorBenefits />
        <AIFeatures />
        <Testimonials />
        <FAQ />
        <div id="get-monetized">
          <WaitlistCTA />
        </div>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
